import React, { Component } from 'react';
import PropTypes from 'prop-types';

import * as style from './timelineCounters.module.scss';
import { Motion, spring } from 'react-motion';

const digits = [9, 8, 7, 6, 5, 4, 3, 2, 1, 0];

const NumCounter = ({ number }) => {
  const height = 40;
  return (
    <div className={style.numCounter}>
      <Motion
        style={{
          top: spring((number - 9) * height, { stiffness: 125, damping: 20 }),
        }}
      >
        {({ top }) => (
          <div
            className={style.counterSlide}
            style={{
              transform: `translateY(${top}px)`,
            }}
          >
            {digits.map(d => <span key={`digit${d}`}>{d}</span>)}
          </div>
        )}
      </Motion>
    </div>
  );
};

class TimelineCounters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayBombCount: this.props.bombCount
        ? this.getCountArray(this.props.bombCount, 5)
        : ['0', '0', '0', '0', '0'],
    };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.bombCount !== this.props.bombCount) {
      this.updateCount(nextProps.bombCount, 5);
    }
  }
  getCountArray(targetCount, targetLength) {
    if (!(typeof targetCount === 'number' || typeof targetCount === 'string')) {
      return;
    }
    const numArray = targetCount.toString().split('');
    const startLength = numArray.length;
    for (let i = 0; i < targetLength - startLength; i++) {
      numArray.unshift('0');
    }
    return numArray;
    /* this.setState({
      [field]: numArray,
    }); */
  }

  updateCount = (targetCount, targetLength) => {
    this.setState({
      displayBombCount: this.getCountArray(targetCount, targetLength),
    });
  };

  render() {
    return (
      <div className={style.counters}>
        <div className={style.counterItem}>
          <span className={style.label}>Bombs in the world</span>
          <span className={style.bombCount}>
            <NumCounter number={parseInt(this.state.displayBombCount[0], 10)} />
            <NumCounter number={parseInt(this.state.displayBombCount[1], 10)} />
            <NumCounter number={parseInt(this.state.displayBombCount[2], 10)} />
            <NumCounter number={parseInt(this.state.displayBombCount[3], 10)} />
            <NumCounter number={parseInt(this.state.displayBombCount[4], 10)} />
          </span>
        </div>
      </div>
    );
  }
}

TimelineCounters.propTypes = {
  bombCount: PropTypes.string.isRequired,
};
export default TimelineCounters;
